import { theme } from 'modules/ui';
import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';

export const StyledCookieWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;

  display: flex;
  flex-direction: column;

  z-index: 10000;

  ${mediaQuery('md')} {
    flex-direction: row;
  }
`;

export const StyledOverlay = styled.div`
  height: 4.688rem;
  width: 100%;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: none;

  ${mediaQuery('md')} {
    height: 100%;
    width: 65.625rem;
    flex: 1;
  }
`;

export const StyledCookieModal = styled.div`
  height: 37rem;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  padding: 2.5rem;
  gap: 1.875rem;
  background: ${theme.colors.primaryW};

  > * {
    width: 21.563rem;
    margin-bottom: 0;
  }

  ${mediaQuery('md')} {
    height: 100%;
    width: 26.688rem;
    flex: 0;

    > * {
      width: 21.688rem;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  > * {
    width: 100%;
  }

  > :first-child {
    margin-bottom: 0.813rem;
  }
`;
